import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import { formatPhoneNumber } from "utils/data-formatters"
import styles from "./BookingForm.module.css"

// New Booking step 2's client (redesign, Figma 5796:176781): name, email and phone on one strip. The
// design pairs the phone icon with the email and the mail icon with the phone; each icon goes with
// its own field here.
const ClientStrip = ({ name, email, phone }) => {
  const { t } = useTranslation()
  const details = [
    { key: "name", icon: "User", text: name },
    { key: "email", icon: "Mail", text: email },
    { key: "phone", icon: "Phone", text: phone ? formatPhoneNumber(phone) || phone : "" }
  ].filter((detail) => detail.text)
  return (
    <Flex vertical gap="var(--spacing-s)" className={styles.stepSection}>
      <span className={styles.stepSectionTitle}>{t("booking.client_strip.title")}</span>
      <Flex wrap gap="var(--spacing-xl)" align="center" className={styles.clientStrip}>
        {details.map((detail) => (
          <Flex key={detail.key} align="center" gap="var(--spacing-xs)" className={styles.clientStripItem}>
            <Icon type="feather" name={detail.icon} width={20} height={20} color="currentColor" />
            <span>{detail.text}</span>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

ClientStrip.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string
}

ClientStrip.defaultProps = {
  name: "",
  email: "",
  phone: ""
}

export default ClientStrip
